import Vue from 'vue'
import Router from 'vue-router'

import { basePath } from '@/config'

Vue.use(Router)

// 解决两次点击同一个路由
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const NotFound = () => import('../views/NotFound') // 404
// const IndexPage = () => import('../views/IndexPage') // 首页
const CourseCenter = () => import('../views/CourseCenter') // 选课中心
// const CourseDetail = () => import('../views/CourseDetail') // 课程详情页
const NewCourseDetail = () => import('../views/NewCourseDetail') // 新课程详情页
const AddPurchase = () => import('../views/AddPurchase') // 加价购页面
const TeacherInfo = () => import('../views/TeacherInfo') // 老师主页
// const RedirectOldIndex = () => import('../views/RedirectOldIndex') // 旧首页兼容
const RedirectOldCenter = () => import('../views/RedirectOldCenter') // 旧选课中心兼容
const Article = () => import('../views/Article') // 文章页
const ArticleNav = () => import('../views/ArticleNav') // 文章页导航
const DownLoad = () => import('../views/DownLoad') // 客户端下载页
const Feedback = () => import('../views/Feedback') // 反馈下载页
const SearchPage = () => import('../views/SearchPage') // 搜索页
const BusinessLicense = () => import('../views/BusinessLicense') // 搜索页

const resolve = (path = '') => `${basePath}/${path}`

export function createRouter() {
  return new Router({
    mode: 'history',
    fallback: false,
    scrollBehavior: (to, from) => (to.name !== from.name ? { y: 0 } : ''),
    routes: [
      // 客户端下载页
      {
        path: resolve('search'),
        name: 'search',
        component: SearchPage,
        pageuid: '1.1.0'
      },
      {
        path: '/d',
        name: 'downLoad',
        component: DownLoad,
        pageuid: '1.8.0'
      },
      {
        path: resolve('Article'),
        name: 'article-nav',
        component: ArticleNav
      },
      {
        path: '/404',
        name: '404',
        component: NotFound
      },
      {
        path: '/StudentFeedback/apply',
        name: 'feedback',
        component: Feedback
      },
      {
        path: '/businessLicense',
        name: 'businessLicense',
        component: BusinessLicense
      },
      // {
      //   path: '/index/:grade?',
      //   redirect: { name: 'index-page-old' }
      // },
      // {
      //   path: '/',
      //   name: 'enter',
      //   component: IndexPage,
      //   children: [
      //     {
      //       path: '/s:grade?',
      //       name: 'index-page',
      //       component: IndexPage
      //     }
      //   ]
      // },
      // {
      //   path: '/:grade?',
      //   name: 'index-page-old',
      //   component: RedirectOldIndex
      // },
      {
        path: resolve('course-center/s:courseType/s:grade/s:subject'),
        name: 'course-center',
        component: CourseCenter,
        pageuid: '1.2.0'
      },
      {
        path: resolve('course-center/:courseType/:grade/:subject'),
        name: 'redirect-old',
        component: RedirectOldCenter,
        pageuid: '1.2.0'
      },
      {
        path: resolve('course-detail/:courseId/:classId?'),
        name: 'course-detail',
        component: NewCourseDetail,
        pageuid: '1.3.0'
      },
      {
        path: resolve('new-course-detail/:courseId/:classId?'),
        name: 'new-course-detail',
        component: NewCourseDetail,
        pageuid: '1.3.0'
      },
      {
        path: resolve('add-purchase/:courseId/:classId?'),
        name: 'add-purchase',
        component: AddPurchase,
        pageuid: '1.5.0'
      },
      {
        path: resolve('t/:teacherId?'),
        name: 'teacher-info',
        component: TeacherInfo,
        pageuid: '1.6.0'
      },
      {
        path: resolve('article/detail/:id'),
        name: 'article',
        component: Article,
        pageuid: '1.7.0'
      },
      {
        path: '*',
        name: '404-page',
        component: NotFound
      }
    ]
  })
}



// WEBPACK FOOTER //
// ./src/router/index.js